import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';

@Component({
  selector: 'app-bill-payment-ehcard-number',
  templateUrl: './bill-payment-ehcard-number.component.html',
  styleUrls: ['./bill-payment-ehcard-number.component.css']
})
export class BillPaymentEhcardNumberComponent implements OnInit {

  TAG = "BillPaymentEhcardNumberComponent";

  // @Input() invoiceID: string;

  editForm: FormGroup;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private log: LoggerService,

  ) { }

  ngOnInit() {
    this.editForm = this.formBuilder.group({
      ehCardVoucher: ['', [Validators.required , Validators.pattern('^[a-zA-Z0-9_-]*$')]],
    });
  }

  cancel() {
    this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }

  get f() { return this.editForm.controls; }

  confirm() {
    this.submitted = true;

    var ehCardInputVoucher = this.editForm.get('ehCardVoucher').value.trim();
    this.editForm.patchValue({'ehCardVoucher':ehCardInputVoucher});

    this.log.i(this.TAG, "do confirm value ="+ehCardInputVoucher);

    if (this.editForm.valid && ehCardInputVoucher != '') {

      var returnJson = JSON.stringify({ehCardConfirmedID:ehCardInputVoucher},null,"    ");

      this.activeModal.close(returnJson);

    }else{
      alert('請輸入正確醫療劵格式');
    }

  }



}
